export default "__VITE_ASSET__DwrBrVJg__"